import { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { AccountPermission } from 'modules/permissions/constants';
import { GuardAccountPermission } from 'modules/account/components/GuardAccountPermission';
import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { Placeholder } from 'modules/common/components/Placeholder';
import { chainsRoutesConfig } from 'domains/chains/routes';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { LoggingInGuard } from 'modules/auth/components/LoggingInGuard';

export interface BillingAccessGuardProps {
  children: ReactNode;
  fallback: ReactNode;
  loginFallback?: ReactNode;
  premissionFallback?: ReactNode;
}

const chainsPath = chainsRoutesConfig.chains.generatePath();

export const BillingAccessGuard = ({
  children,
  fallback,
  loginFallback,
  premissionFallback,
}: BillingAccessGuardProps) => {
  const { isEnterprise } = useAccountStatus();

  return (
    <NoSSRGuard>
      <LoggingInGuard fallback={loginFallback || <Navigate to={chainsPath} />}>
        <Placeholder hasPlaceholder={isEnterprise} placeholder={fallback}>
          <GuardAccountPermission
            fallback={premissionFallback}
            permission={AccountPermission.Billing}
            shouldHideAlert
            shouldRedirect
          >
            {children}
          </GuardAccountPermission>
        </Placeholder>
      </LoggingInGuard>
    </NoSSRGuard>
  );
};
